import { App } from 'realm-web';

export const realmApp = new App(import.meta.env.VITE_MONGO_API_ID);
